<span class="iris-user-avatar" [ngClass]="avatarSizeClass">
  @if (hasAvatar && !avatarLoadingError) {
    <span
      class="image">
      <img [src]="avatarLink" alt="" (error)="avatarLoadingError=true" />
    </span>
  }
  @if ((!hasAvatar || avatarLoadingError) && userExists) {
    <span
      class="user-no-avatar first-letters-avatar">
      <span>{{ userInitials }}</span>
    </span>
  }
  @if (!userExists) {
    <span
      class="user-no-avatar gray">
      <i class="fas fa-user"></i>
    </span>
  }
</span>
